<template>
  <div class="base-simple-layout">
    <BaseHeader class="header" />
    <div class="main">
      <div class="sidebar-container">
        <slot name="sidebar" />
      </div>
      <div
        :style="{ width: sidebarVisible ? 'calc(100% - 310px)' : '100%' }"
        class="main-content"
      >
        <div class="header-container">
          <div class="page-title">
            <slot name="title" />
          </div>
          <div class="header-button-area">
            <slot name="button-area" />
          </div>
        </div>
        <div class="main-container">
          <slot name="main" />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
  import { defineComponent } from 'vue';
  import BaseHeader from '@/components/BaseHeader.vue';

  export default defineComponent({
    name: 'BaseSimpleLayout',
    components: {
      BaseHeader
    },
    props: {
      sidebarVisible: {
        type: Boolean,
        default: false
      }
    }
  });
</script>

<style lang="scss">
  .base-simple-layout {
    .main {
      padding-top: 60px;
      display: flex;
      height: calc(100vh - 60px);
      .sidebar-container {
        min-width: fit-content;
        width: fit-content;
        transition: width 0.3s ease;
        overflow: hidden;
        border-right: 1px solid #ebeef5;
        background-color: #fff;
      }
      .main-content {
        flex: 1;
        transition: margin-left 0.3s ease;
      }
    }
    .header-container {
      display: flex;
      height: 40px;
      width: 90%;
      margin: auto;

      .header-button-area {
        width: 70%;
        text-align: right;
      }
      .page-title {
        text-align: left;
        font-weight: 600;
        width: 100%;
        font-size: 25px;
      }
    }
    .main-container {
      margin: auto;
      width: 90%;
      overflow-x: scroll;
    }
  }
</style>
